import React from 'react';
import { BoldTitle } from '../../../CustomizedComponents/Texts';
import SectionWrapper from '../../../CardRow/SectionWrapper';
import { FormattedMessage } from 'react-intl';
import CustomTextField from '../../../CustomizedComponents/CustomTextField';
import PropTypes from 'prop-types';
import CustomNumberFormat from '../../../CustomizedComponents/CustomNumberFormat';

const TradingOther = (
  {
    data,
    handler,
    editable,
  },
) => {
  const priceValidityTitle = 'app.configuration.priceValidity';
  const fixMarginMonth1Title = 'app.configuration.fixSurchargeMonth1';
  const fixMarginMonth2Title = 'app.configuration.fixSurchargeMonth2';
  const fixMarginMonth3Title = 'app.configuration.fixSurchargeMonth3';
  const fixMarginMonth4Title = 'app.configuration.fixSurchargeMonth4';
  const fixMarginMonth5Title = 'app.configuration.fixSurchargeMonth5';
  const fixMarginMonth6Title = 'app.configuration.fixSurchargeMonth6';
  const fixMarginMonth7Title = 'app.configuration.fixSurchargeMonth7';
  const fixMarginQuarter1Title = 'app.configuration.fixSurchargeQuarter1';
  const fixMarginQuarter2Title = 'app.configuration.fixSurchargeQuarter2';
  const fixMarginQuarter3Title = 'app.configuration.fixSurchargeQuarter3';
  const fixMarginQuarter4Title = 'app.configuration.fixSurchargeQuarter4';
  const fixMarginQuarter5Title = 'app.configuration.fixSurchargeQuarter5';
  const fixMarginYear1Title = 'app.configuration.fixSurchargeYear1';
  const fixMarginYear2Title = 'app.configuration.fixSurchargeYear2';
  const fixMarginYear3Title = 'app.configuration.fixSurchargeYear3';
  const fixMarginYear4Title = 'app.configuration.fixSurchargeYear4';
  const floatMarginTitle = 'app.configuration.floatingSurcharge';
  const currency = 'app.currency.eur';
  const minutesTitle = 'app.time.min';

  return (
    <>
      <SectionWrapper>
        <BoldTitle title={'app.other'} />
      </SectionWrapper>
      <SectionWrapper>
        <CustomTextField
          id="priceValidityInMinutes"
          name="priceValidityInMinutes"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, priceValidityInMinutes: target.value };
              });
            }
          }
          label={<FormattedMessage id={priceValidityTitle} />}
          value={data?.priceValidityInMinutes}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={minutesTitle} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginMonth1"
          name="fixMarginMonth1"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginMonth1: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginMonth1Title} />}
          value={data?.fixMarginMonth1}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginMonth2"
          name="fixMarginMonth2"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginMonth2: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginMonth2Title} />}
          value={data?.fixMarginMonth2}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginMonth3"
          name="fixMarginMonth3"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginMonth3: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginMonth3Title} />}
          value={data?.fixMarginMonth3}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginMonth4"
          name="fixMarginMonth4"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginMonth4: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginMonth4Title} />}
          value={data?.fixMarginMonth4}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginMonth5"
          name="fixMarginMonth5"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginMonth5: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginMonth5Title} />}
          value={data?.fixMarginMonth5}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginMonth6"
          name="fixMarginMonth6"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginMonth6: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginMonth6Title} />}
          value={data?.fixMarginMonth6}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginMonth7"
          name="fixMarginMonth7"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginMonth7: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginMonth7Title} />}
          value={data?.fixMarginMonth7}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginQuarter1"
          name="fixMarginQuarter1"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginQuarter1: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginQuarter1Title} />}
          value={data?.fixMarginQuarter1}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginQuarter2"
          name="fixMarginQuarter2"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginQuarter2: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginQuarter2Title} />}
          value={data?.fixMarginQuarter2}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginQuarter3"
          name="fixMarginQuarter3"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginQuarter3: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginQuarter3Title} />}
          value={data?.fixMarginQuarter3}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginQuarter4"
          name="fixMarginQuarter4"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginQuarter4: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginQuarter4Title} />}
          value={data?.fixMarginQuarter4}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginQuarter5"
          name="fixMarginQuarter5"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginQuarter5: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginQuarter5Title} />}
          value={data?.fixMarginQuarter5}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginYear1"
          name="fixMarginYear1"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginYear1: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginYear1Title} />}
          value={data?.fixMarginYear1}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginYear2"
          name="fixMarginYear2"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginYear2: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginYear2Title} />}
          value={data?.fixMarginYear2}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginYear3"
          name="fixMarginYear3"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginYear3: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginYear3Title} />}
          value={data?.fixMarginYear3}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="fixMarginYear4"
          name="fixMarginYear4"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, fixMarginYear4: target.value };
              });
            }
          }
          label={<FormattedMessage id={fixMarginYear4Title} />}
          value={data?.fixMarginYear4}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
        <CustomTextField
          id="floatingMaxMargin"
          name="floatingMaxMargin"
          onChange={
            (event) => {
              const target = event.target;
              handler((oldState) => {
                return { ...oldState, floatingMaxMargin: target.value };
              });
            }
          }
          label={<FormattedMessage id={floatMarginTitle} />}
          value={data?.floatingMaxMargin}
          variant="outlined"
          disabled={!editable}
          InputProps={{
            inputComponent: CustomNumberFormat,
            endAdornment: (
              <FormattedMessage id={currency} />
            ),
          }}
        />
      </SectionWrapper>
    </>
  );
};

TradingOther.propTypes = {
  data: PropTypes.object,
  editable: PropTypes.bool,
  handler: PropTypes.func,
};

export default TradingOther;
